import WarIntel from './WarIntel';
import WarIntelQuiz from './WarIntelQuiz';
import WarIntro from './WarIntro';

export default [WarIntro, WarIntel, WarIntelQuiz];
